import axios from 'axios';

import { uiActions } from '../ui-slice';
import { form2Actions } from './form2-slice';

import { GET_QUOTES_URL, NAVIGATION_PATHS } from '../../constants/constants';
import { doNavigation } from '../../utils/helper-functions';

export const form2Transaction = (
  token,
  keyGS,
  postalCode,
  typeVehicle,
  brand,
  subbrand,
  model,
  version,
  currentStep,
  navigateHook,
) => {
  const formData = {
    tipoValor: 'comercial',
    claveGs: keyGS,
    prefijo: typeVehicle === 'auto' ? 'AR' : 'PP',
    cp: postalCode,
    modelo: model,
    numeroDias: 14,
  };

  const redirectCall = () => {
    window.location.href = 'tel:5571003159';
  };

  return async (dispatch) => {
    dispatch(uiActions.setLoaderStatus({ type: 'simple' }));
    axios
      .post(
        GET_QUOTES_URL,
        formData,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      )
      .then((res) => {
        if (res.data.status === 'error') {
          throw new Error(res.data.message);
        } else {
          const responseData = res
            && res.data
            && res.data.data
            && res.data.data.planes;
          if (responseData) {
            dispatch(form2Actions.setForm2TransactionData({
              typeVehicle,
              typeVehiclePrefix: formData.prefijo,
              brand,
              subbrand,
              model,
              version,
              versionKeyGS: keyGS,
              planes: responseData,
            }));
            doNavigation(currentStep, 'forward', navigateHook, dispatch, true);
          } else {
            throw new Error('No se obtuvieron las cotizaciones correctamente.');
          }
        }
      })
      .catch((err) => {
        let errMsg = '';
        if (err.message !== '' && !err.message.includes('Request')) {
          errMsg = err.message;
        }
        dispatch(uiActions.setErrorStatus({
          type: 'generic',
          title: 'Ha ocurrido un error',
          body: errMsg || 'Hubo un error al obtener tu cotización',
          specialContent: {
            textParts: [
              'No hemos podido concluir con tu cotización en línea, llama al ',
              { bold: '55 7100 3159' },
              ' para finalizar tu solicitud. ',
              { bold: 'Horarios de atención:', lineBreak: true },
              ' Lunes a Viernes de 8 a 21 horas y sábados de 9 a 17 hrs.',
            ],
            buttons: [
              {
                icon: 'phone',
                label: '55 7100 3159',
                action: redirectCall,
                buttonClasses: 'align-center -secondary-primary-color -mt-10',
              },
            ],
          },
          onCloseNavigate: NAVIGATION_PATHS[1],
        }));
        throw err;
      });
  };
};
